import axios from 'axios' // eslint-disable-line no-restricted-imports

export const auth0Client = axios.create({
  baseURL: process.env.NEXT_PUBLIC_AUTH0_API,
})
